import React, { Component } from 'react'

export class PopOver extends Component {
  constructor ( props ) {
    super( props )

    this.el = React.createRef()
    this.handleClick = this.handleClick.bind( this )
  }

  componentDidMount () {
    document.addEventListener( 'mousedown', this.handleClick )
  }

  componentWillUnmount () {
    document.removeEventListener( 'mousedown', this.handleClick )
  }

  handleClick ( e ) {
    const { hidePopover } = this.props

    if( this.el.current.contains( e.target ) ) {
      return
    }

    if( hidePopover && typeof hidePopover === 'function' ) {
      hidePopover()
    }
  }

  render () {
    const { className } = this.props
    return (
      <div ref={this.el} className={className}>
        {this.props.children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/commons/PopOver.js